"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Member = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _MemberModule = _interopRequireDefault(require("./Member.module.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var Member = _ref => {
  var label = _ref.label,
    href = _ref.href,
    children = _ref.children,
    className = _ref.className,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'primary' : _ref$variant;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_MemberModule.default.Container, className)
  }, /*#__PURE__*/_react.default.createElement("label", {
    className: _MemberModule.default.Label,
    "data-variant": variant
  }, label), href ? /*#__PURE__*/_react.default.createElement("a", {
    className: _MemberModule.default.Content,
    href: href,
    target: '_blank',
    rel: 'noreferrer'
  }, children) : /*#__PURE__*/_react.default.createElement("div", {
    className: _MemberModule.default.Content
  }, children));
};
exports.Member = Member;
//# sourceMappingURL=Member.js.map